import ValueObserver from 'src/util/ValueObserver'

export default new ValueObserver()
